import { Box, Stack } from '@mui/material';
import { InformationOutlinedIcon, ThemeWrapper } from '@synergy/theme-next';
import { PoolTooltip, PoolTypography } from '@synergy/components-next';

import { BonusConditionMode } from '../../models/customer-bonus-settlement-supplier';

interface BonusSettlementDetailBonusConditionTooltipProps {
    title: string;
    mode: BonusConditionMode;
}

export const BonusSettlementDetailBonusConditionTooltip = (props: BonusSettlementDetailBonusConditionTooltipProps) => {
    const { title, mode } = props;

    return (
        <ThemeWrapper>
            <PoolTooltip
                title={
                    <Stack>
                        <Box>
                            <PoolTypography
                                sx={{ fontWeight: 600 }}
                                variant="body2"
                                translationId={
                                    mode === BonusConditionMode.Amount
                                        ? 'app.bonusSettlements.detail.bonusCondition.mode.amount'
                                        : 'app.bonusSettlements.detail.bonusCondition.mode.percentage'
                                }
                            />
                        </Box>
                        <PoolTypography variant="body2">{title}</PoolTypography>
                    </Stack>
                }
                variant="light"
            >
                <InformationOutlinedIcon
                    sx={{
                        color: theme => theme.palette.grey[700],
                        width: 20,
                        height: 20,
                    }}
                />
            </PoolTooltip>
        </ThemeWrapper>
    );
};
